import { Circle, User, Shield, Briefcase, FileText } from "react-feather";

import {
  ADMIN_USERS_LIST_PATH,
  CLIENT_USERS_LIST_PATH,
  BUSINESS_USERS_LIST_PATH,
} from "@src/views/apps/user/paths";
import {
  BUSINESSES_LIST_PATH,
  BUSINESS_POLICIES_LIST_PATH,
} from "@src/views/apps/business/paths";
import { ROLES_PATH, PERMISSIONS_PATH } from "@src/views/apps/roles-permissions/paths";
import { navPerm } from "../navPermissions";
import { PERMISSION_MODULE } from "@src/utility/permissions/modulePermissions";

export default [
  {
    header: "User Management",
  },
  {
    id: "roles-permissions",
    title: "Roles & Permissions",
    icon: <Shield size={20} />,
    children: [
      {
        id: "roles",
        title: "Roles",
        icon: <Circle size={12} />,
        navLink: ROLES_PATH,
        ...navPerm(PERMISSION_MODULE.ROLE),
      },
      {
        id: "permissions",
        title: "Permissions",
        icon: <Circle size={12} />,
        navLink: PERMISSIONS_PATH,
        ...navPerm(PERMISSION_MODULE.PERMISSION),
      },
    ],
  },
  {
    id: "users",
    title: "Users",
    icon: <User size={20} />,
    children: [
      {
        id: "admin-users",
        title: "Admin Users",
        icon: <Circle size={12} />,
        navLink: ADMIN_USERS_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.USER),
      },
      {
        id: "client-users",
        title: "Client Users",
        icon: <Circle size={12} />,
        navLink: CLIENT_USERS_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.APP_USER),
      },
      {
        id: "business-users",
        title: "Business Users",
        icon: <Circle size={12} />,
        navLink: BUSINESS_USERS_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.BUSINESS_USER),
      },
    ],
  },
  {
    id: "business",
    title: "Business",
    icon: <Briefcase size={20} />,
    children: [
      {
        id: "businesses",
        title: "Businesses",
        icon: <Circle size={12} />,
        navLink: BUSINESSES_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.BUSINESS),
      },
      {
        id: "policies",
        title: "Business Policies",
        icon: <Circle size={12} />,
        navLink: BUSINESS_POLICIES_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.BUSINESS_POLICY),
      },
    ],
  },
];
